import Image from 'next/image';
import styles from './BlogImageWithCaption.module.css';

const BlogImageWithCaption = ({src, alt, caption, ...props}) => {
  return (
    <div className="relative flex flex-col items-center">
      <div className={styles.nextImageContainer}>
        <Image
          layout="fill"
          className={`next-blog-image !mb-2 ${styles.image}`}
          src={src}
          alt={alt}
          {...props}
        />
      </div>

      <span className="text-sm italic">{caption}</span>
    </div>
  );
};

export default BlogImageWithCaption;
